module.exports = __webpack_public_path__ + "static/img/erweima.93ccd4a5.gif";